import { AxiosRequestConfig, AxiosInstance } from 'axios';
import { currentVersion } from './version';
import { createApiInstance } from './axiosInstance';

export const PREFIX_PATH = `${process.env.NEXT_PUBLIC_API_PREFIX}/${currentVersion}`;

export const getApiBaseUrl = (isServer: boolean): string => {
  if (isServer) {
    return process.env.INTERNAL_API_ENDPOINT || process.env.NEXT_PUBLIC_ENDPOINT!;
  } else {
    return process.env.NEXT_PUBLIC_ENDPOINT!;
  }
};

// api prefix

// api prefix
let clientApiInstance: AxiosInstance | null = null;

export const qdfoodApi = (isServer = typeof window === 'undefined') => {
  if (isServer) {
    return createApiInstance({
      endpoint: getApiBaseUrl(isServer),
      prefixPath: PREFIX_PATH,
    });
  }

  if (!clientApiInstance) {
    clientApiInstance = createApiInstance({
      endpoint: getApiBaseUrl(isServer),
      prefixPath: PREFIX_PATH,
    });
  }

  return clientApiInstance;
};

export const fetcherSWR = (url: string, config?: AxiosRequestConfig) =>
  qdfoodApi()
    .get(url, config)
    .then((res) => res.data);
